export default "__VITE_ASSET__9OxeycfE__"